import type React from "react";
import { Loading } from "@/v2/ui/composed/loading";
import { Button } from "@/v2/ui/primitives/button";

interface ButtonWithLoaderProps {
  text?: string;
  isLoading?: boolean;
}

const ButtonWithLoader: React.FC<ButtonWithLoaderProps> = ({
  text = "",
  isLoading = false,
}) => {
  return (
    <Button type="submit" disabled={isLoading}>
      {isLoading ? <Loading size="sm" /> : text}
    </Button>
  );
};

export default ButtonWithLoader;
